const PREFIX = "app"; // namespace (important for scaling)

const buildKey = (key) => `${PREFIX}:${key}`;

export const storageService = {
    get(key, defaultValue = null) {
        try {
            const value = localStorage.getItem(buildKey(key));
            return value !== null ? JSON.parse(value) : defaultValue;
        } catch (e) {
            console.error(`storageService.get error for key: ${key}`, e);
            return defaultValue;
        }
    },

    set(key, value) {
        try {
            localStorage.setItem(buildKey(key), JSON.stringify(value));
        } catch (e) {
            console.error(`storageService.set error for key: ${key}`, e);
        }
    },
    update(key, partialValue) {
        try {
            const current = this.get(key);

            // If value is not an object, fallback to set
            if (
                current === null ||
                typeof current !== "object" ||
                Array.isArray(current)
            ) {
                this.set(key, partialValue);
                return;
            }

            const updatedValue = {
                ...current,
                ...partialValue,
            };

            this.set(key, updatedValue);
        } catch (e) {
            console.error(`storageService.update error for key: ${key}`, e);
        }
    },

    remove(key) {
        localStorage.removeItem(buildKey(key));
    },



    clear() {
        Object.keys(localStorage)
            .filter((k) => k.startsWith(`${PREFIX}:`))
            .forEach((k) => localStorage.removeItem(k));
    },
};
